import { Routes } from '@angular/router';
import { APP_ROUTE_PATHS } from '../core/routing/app-route-paths';

export const SHUTTLE_ROUTES: Routes = [
  {
    path: APP_ROUTE_PATHS.shuttle,
    loadComponent: () =>
      import('./shuttle-page.component').then((m) => m.ShuttlePageComponent)
  }
];
